import React from "react";
import { FadeUp, SectionLabel } from "./Motion";
import { useContent } from "../context/ContentContext";

const About = () => {
  const { content } = useContent();
  return (
    <section id="about" className="relative py-28 md:py-40" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <FadeUp><SectionLabel num="01">{content.mission_eyebrow}</SectionLabel></FadeUp>
        <div className="mt-10 md:mt-16 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
          <FadeUp delay={0.05} className="md:col-span-8">
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-[-0.02em] text-black" data-testid="about-headline">
              {content.mission_headline}
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="md:col-span-4 md:pt-3">
            <p className="text-zinc-600 text-base md:text-lg leading-relaxed" data-testid="about-body">
              {content.mission_body}
            </p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};

export default About;
